import {PopupNotification} from "./lib/PopupNotification.js";

const navigationBarMenuButton = <HTMLAnchorElement|null>document.getElementById("navbar-button");
const navigationBarMenu = <HTMLAnchorElement>document.getElementById("navbar-menu");
const buttonLogout = <HTMLButtonElement|null>document.getElementById("button-logout");
const notificationElementLogoutError = <HTMLDivElement>document.getElementById("notification-logout-error");

const notificationLogoutError = new PopupNotification(notificationElementLogoutError);

if(buttonLogout !== null){
    buttonLogout.addEventListener("click", async () => {
        const response = await fetch("/auth/logout", {
            method: "POST",
            headers: new Headers({
                /* eslint-disable @typescript-eslint/naming-convention */
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8"
                /* eslint-enable @typescript-eslint/naming-convention */
            }),
            body: JSON.stringify({})
        });

        if(response.ok){
            globalThis.location.href = "/auth/login";
        }else{
            notificationLogoutError.show();
        }
    });
}

if(navigationBarMenuButton !== null){
    navigationBarMenuButton.addEventListener("click", () => {
        const menuButtonState = navigationBarMenuButton.classList.toggle("is-active");
        navigationBarMenu.classList.toggle("is-active", menuButtonState);
    });
}